<ng-container *ngIf="value">
    <div class="message-buttons">
      <a [href]="value" target="_blank" class="message-button">
        <ng-container *ngIf="value"><i class="{{icon}}"></i></ng-container>{{value}}
      </a>
    </div>
  </ng-container>
  